import StoreConnector from '@/helpers/StoreConnector'
import additionalOrder from './additionalOrder'

export default {
  mixins: [additionalOrder],
  methods: {
    addToSelected(selectedProduct) {
      StoreConnector.dispatch(`${this.quoteNamespace}/addToAccessories`, selectedProduct)
      selectedProduct.PackageSubItems.forEach(this.tryGetAccessoryAndAddToStore)
    },
    removeFromSelected(deselectedProduct) {
      StoreConnector.dispatch(`${this.quoteNamespace}/removeFromAccessories`, deselectedProduct)
    },
    modifyAccessory(deselectedProduct) {
      StoreConnector.dispatch(`${this.quoteNamespace}/modifyAccessory`, deselectedProduct)
    },
    tryGetAccessoryAndAddToStore(id) {
      StoreConnector.getWithParam('accessories/getMatchingAccessory', id, (matchingAccessory) => {
        if (!matchingAccessory) return
        StoreConnector.dispatch(`${this.quoteNamespace}/addToAccessories`, matchingAccessory)
      })
    },
    resetAllWeatherTyresPL(callSaveQuote) {
      StoreConnector.dispatch(
        `${this.quoteNamespace}/resetAccessoryAllWeatherTyresPL`,
        callSaveQuote
      )
    },
  },
}
